__turbopack_context__.v({
  "time": "PriceTimer-module-scss-module__OJieuG__time",
  "timer": "PriceTimer-module-scss-module__OJieuG__timer",
  "timer-lg": "PriceTimer-module-scss-module__OJieuG__timer-lg",
});
